"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const close_button_1 = require("../close-button");
const styles_1 = require("./styles");
const Modal = (props) => {
    const modal = (0, react_1.useRef)(null);
    const { isOpen, close, hasBackground = true, backgroundColor = '#FFF', closeWhenOverlayIsClicked = true, hasOverlay = true, overlayColor = 'rgba(0,0,0,.75)', scrollable = false, closeButtonColor = '#616161', closeButtonSize = close_button_1.CloseButtonSize.Medium, closeButtonHoverEffect = close_button_1.CloseButtonHoverProps.Darken, hasCloseButton = false } = props;
    const handleTab = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            const interactibleChildren = modal.current
                ? Array.from(modal.current.querySelectorAll("a, button, input, select, textarea, [tabindex]:not([tabindex='-1'])")).sort((a, b) => a.tabIndex - b.tabIndex)
                : [];
            if (interactibleChildren.length > 0) {
                const index = interactibleChildren.findIndex((child) => child === document.activeElement);
                let nextIndex = index;
                if (event.shiftKey) {
                    nextIndex = index === 0 ? interactibleChildren.length - 1 : index - 1;
                }
                else {
                    nextIndex = index === interactibleChildren.length - 1 ? 0 : index + 1;
                }
                interactibleChildren[nextIndex].focus();
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if ((0, monera_app_core_1.isClientSide)() && window.P) {
            const type = isOpen ? 'appOverlays.Hide' : 'appOverlays.Show';
            window.P.when('mash').execute((mash) => mash.dispatchEvent({ type }));
        }
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    const overlayClickHandler = () => {
        if (closeWhenOverlayIsClicked) {
            close();
        }
    };
    const contentClickHandler = (event) => {
        event.stopPropagation();
    };
    const closeButtonClickHandler = () => {
        close();
    };
    return (isOpen && (react_1.default.createElement(styles_1.ModalOverlay, { container: true, scrollable: scrollable, justify: "center", alignItems: "center", hasOverlay: hasOverlay, overlayColor: overlayColor, "data-cy": 'modal-overlay', onClick: overlayClickHandler, onKeyDown: (event) => {
            if (event.key === 'Escape') {
                close();
            }
        } },
        react_1.default.createElement(styles_1.ModalContent, { role: "dialog", scrollable: scrollable, backgroundColor: backgroundColor, hasBackground: hasBackground, hasCloseButton: hasCloseButton, onClick: contentClickHandler },
            react_1.default.createElement("span", { id: "modal-ref", ref: modal, onKeyDown: handleTab },
                hasCloseButton ? (react_1.default.createElement(styles_1.CloseButtonContainer, null,
                    react_1.default.createElement(close_button_1.CloseButton, { color: closeButtonColor, size: closeButtonSize, margin: '-3px -8px 0 0', hoverEffect: closeButtonHoverEffect, onClick: closeButtonClickHandler }))) : null,
                props.children)))));
};
exports.default = Modal;
